exports.components = {
  "component---src-pages-index-jsx": () => import("./../../../src/pages/index.jsx" /* webpackChunkName: "component---src-pages-index-jsx" */),
  "component---src-pages-job-jsx": () => import("./../../../src/pages/job.jsx" /* webpackChunkName: "component---src-pages-job-jsx" */)
}

